export abstract class GoogleTagDirectiveHost {
    abstract getGoogleTagData(): {
        componentName: string,
        textDetail: string,
        numericDetail: number
    };
}